export const baseUrl = 'https://test.trmsdr.com'
export const baseReportUrl = 'https://test.trmsdr.com'
